import { render, staticRenderFns } from "./PersonaFisicaForm.vue?vue&type=template&id=3cebf57c&scoped=true"
import script from "./PersonaFisicaForm.vue?vue&type=script&lang=js"
export * from "./PersonaFisicaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cebf57c",
  null
  
)

export default component.exports